import React, {Component, Fragment} from 'react';
import {Button, Form, Input, InputGroup} from 'reactstrap';

import './Login.css'
import {Link, withRouter} from 'react-router-dom';
import UserSessionService from "../../../services/UserSessionService";
import ToastHelper from "../../../utils/ToastHelper";
import 'react-toastify/dist/ReactToastify.css';
import CookieService, {CookieKey} from "../../../services/CookieService";
import MsisdnSearchStripper from "../../../utils/MsisdnSearchStripper";

class Login extends Component {

    constructor(props) {
        super(props);

        this.state = {
            username: CookieService.getCookie(CookieKey.RETURNING_USER, ""),
            pin: '',
            customer: {}
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.validateForm = this.validateForm.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    validateForm() {
        return this.state.username.length > 0 && this.state.pin.length > 0;
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });

    };

    handleSubmit = function (event) {
        event.preventDefault();
        this.setState({isLoading: true});
        let self = this;
        let username = this.state.username
        if(!username.includes('@')){
            username = MsisdnSearchStripper.stripMsisdn(username)
        }
        UserSessionService.login(username, this.state.pin).then(response => {
            if(response === "Forbidden"){
                ToastHelper.error("Maximum number of authentication attempts exceeded, please retry later.");
                self.setState({isLoading: false, password: ""});
            } else if (response) {
                self.props.userHasAuthenticated();
            } else {
                ToastHelper.formatError("Invalid username or password");
                self.setState({isLoading: false, password: ""});
            }
        });
    };

    render() {
        return <Fragment>
            <div className={"background"}>
                <div className={"center"}>
                    {this.renderLogo()}
                    <Form onSubmit={this.handleSubmit}>
                        {this.renderForm()}
                    </Form>
                    {this.renderFooter()}
                </div>
                 <div className={"powered-by-section"}>
                    Powered by Sikhona Forex
                </div>
            </div>
        </Fragment>
    }

    renderLogo() {
        return <div className={"login_logo_div"}>
           <img className={"browser_login_logo"} src={"./assets/RiaLogoVariations/ria_logo_horizontal_colour.png"} alt=""/>
        </div>
    }

    renderForm() {
        if (this.props.isMobile) {
            return <div>
                <InputGroup className="mb-3">
                    <Input type="text" placeholder="Username" className={"login_input"}
                           id="username"
                           onChange={this.handleChange}
                           value={this.state.username}/>
                </InputGroup>
                <InputGroup className="mb-4">
                    <Input type="password" placeholder="Pin" className={"login_input"}
                           id="pin"
                           onChange={this.handleChange}
                           value={this.state.pin}/>
                </InputGroup>
                {this.renderSignInButton()}
            </div>
        } else {
            return <div className={"browser_login_form"}>
                <InputGroup className="mb-4">
                    <Input type="text" placeholder="Username" className={"login_input"}
                           id="username"
                           onChange={this.handleChange}
                           value={this.state.username}/>
                </InputGroup>
                <InputGroup className="mb-4">
                    <Input type="password" placeholder="Pin" className={"login_input"}
                           id="pin"
                           onChange={this.handleChange}
                           value={this.state.pin}/>
                </InputGroup>
                {this.renderSignInButton()}
            </div>
        }
    }

    renderSignInButton() {

        if (this.props.isMobile) {
            return this.getSignInButton("mobile_signin_button")
        } else {
            return this.getSignInButton("browser_signin_button")
        }
    }

    renderFooter() {
        return <div className={"footer"}>
            <Link to="/forgot-password" style={{color: "black"}}>Forgot Pin?</Link>
            <br/>
            <br/>
            <Link to="/register">Not Registered?</Link>
        </div>
    }

    getSignInButton(className) {
        return <Button type={"submit"} className={"px-4 " + className} onClick={this.handleSubmit}
                       disabled={!this.validateForm()}
        >Sign In
        </Button>;
    }
}

export default withRouter(Login);
